export default __webpack_public_path__ + "sounds/wrong2.mp3";